import { ButtonGroup, Flex, Image, useDisclosure } from "@chakra-ui/react";
import { CustomProfileCard } from "../../components/app/account/profile/AccountProfileCard";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { AccountUserCard } from "../../components/app/account/user/AccountUserCard";
import { Role } from "../../models/enum/role.enum";
import { ButtonCustom } from "../../components/form/controls/form.button";
import { AddIcon } from "@chakra-ui/icons";
import { InviteUserModal } from "../../components/app/account/inviteUser.modal";
import { useState } from "react";
import { AccountIntegrationCard } from "../../components/app/account/integration/AccountIntegrationCard";
import { PlugIcon, Users2Icon, UsersIcon } from "lucide-react";

export const Account = ({}) => {
  const { role } = useSelector((state: RootState) => state.userProfile);

  const [display, setDisplay] = useState(
    role === Role.ADMIN ? "users" : "integrations"
  );

  const handleDisplayChange = (display: "users" | "integrations") => {
    setDisplay(display);
  };

  return (
    <>
      <Flex flexDir="row" w="100%" justifyContent="center">
        <Flex gap="24px" pt="30px">
          <Flex pos="relative" direction="column" gap="24px">
            <Image
              pos="absolute"
              src="/assets/account-bg.png"
              w="100%"
              borderTopRadius="8px"
            />

            <CustomProfileCard />
            <Flex flexDir="column" gap="16px" w="100%" mt="30px">
              <ButtonGroup>
                {role === Role.ADMIN && (
                  <ButtonCustom
                    neutral={display !== "users"}
                    onClick={() => handleDisplayChange("users")}
                    borderRadius="20px"
                    style={{
                      padding: "0 16px",
                    }}
                  >
                    <UsersIcon size={16} style={{ marginRight: "8px" }} />
                    Users
                  </ButtonCustom>
                )}
                <ButtonCustom
                  neutral={display !== "integrations"}
                  onClick={() => handleDisplayChange("integrations")}
                  borderRadius="20px"
                  style={{
                    padding: "0 16px",
                  }}
                >
                  <PlugIcon size={16} style={{ marginRight: "4px" }} />
                  Integrations
                </ButtonCustom>
              </ButtonGroup>
              {role === Role.ADMIN && display === "users" && (
                <AccountUserCard />
              )}
              {display === "integrations" && <AccountIntegrationCard />}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

const InviteUserButton = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { role, email } = useSelector((state: RootState) => state.userProfile);

  return (
    <>
      <ButtonCustom
        hidden={role !== Role.ADMIN}
        onClick={onOpen}
        neutral
        style={{
          width: "120px",
          backgroundColor: "transparent",
        }}
      >
        <Flex flexDir="row" gap="4px" alignItems="center">
          <AddIcon fontSize="12px" />
          Invite user
        </Flex>
      </ButtonCustom>
      <InviteUserModal
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={() => {
          onClose();
        }}
      />
    </>
  );
};
